module.exports = __webpack_public_path__ + "static/assets/2ad521fa7becee021224e373d48ffd1d.gif";